import classNames from "classnames";

const StatusBadge = ({
  active,
  status,
}: {
  active: boolean;
  status: "ACTIVE" | "EXPIRED" | "DRAFT";
}) => {
  return (
    <span
      className={classNames(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        status === "ACTIVE"
          ? "bg-[#DCFCE7] text-[#059669]"
          : status === "DRAFT"
          ? "bg-[#F3F4F6] text-[#6B7280]"
          : "bg-[#FEF3C7] text-[#D97706]"
      )}
    >
      {status === "ACTIVE" ? "Active" : status === "DRAFT" ? "Draft" : "Expired"}
    </span>
  );
};

export default StatusBadge;
